import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ALERT_TIER_COLORS, ALERT_DOT_COLORS, type AlertTier } from "@/lib/alert-tier";
import { cn } from "@/lib/utils";

export function AlertTierBadge({ tier, className }: { tier: AlertTier; className?: string }) {
  return (
    <Badge className={cn(ALERT_TIER_COLORS[tier], "border", className)} variant="outline">
      {tier}
    </Badge>
  );
}

interface AlertTierDotProps {
  tier: AlertTier;
  currentStock?: number | string | null;
  reorderLevel?: number | string | null;
  configured?: boolean; // when false, render neutral gray dot
}

export function AlertTierDot({ tier, currentStock, reorderLevel, configured = true }: AlertTierDotProps) {
  const dotClass = configured ? ALERT_DOT_COLORS[tier] : "bg-zinc-300";
  const tooltipBody = configured
    ? `${Number(currentStock ?? 0)} units · reorder at ${Number(reorderLevel ?? 0)} · ${tier}`
    : "Not configured for replenishment";
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn("h-2.5 w-2.5 rounded-full inline-block", dotClass)}
          aria-label={`Stock alert: ${tier}`}
        />
      </TooltipTrigger>
      <TooltipContent>
        <span className="text-xs">{tooltipBody}</span>
      </TooltipContent>
    </Tooltip>
  );
}
